/**
 * Domains allowed as the source for media (images, videos) embedded in rendered markdown.
 * Source: https://github.com/github/copilot/blob/main/docs/client-guidance/rendering-and-ingestion-guidelines.md#image-rendering
 */
export const trustedMediaDomains = [
  'raw.githubusercontent.com/',
  'private-user-images.githubusercontent.com/',
  'avatars.githubusercontent.com/',
  'gist.github.com/assets/',
  'github.com/user-attachments/assets/',
  'github.localhost/user-attachments/assets/',
]

/** Returns whether `src` is a URL from an explicitly allow-listed media domain. */
export function isTrustedMediaSource(src: string): boolean {
  let url: URL | undefined
  try {
    url = new URL(src, globalThis.location?.origin)
  } catch {
    return false
  }
  const path = url.hostname + url.pathname
  return trustedMediaDomains.some(domain => path.startsWith(domain))
}
